import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarMenu,
  SidebarRail,
} from '@/components/ui/sidebar';
import { useTranslation } from '@/hooks/useTranslation';
import { NavigationGroup } from './NavigationGroup';
import { SidebarFooter } from './SidebarFooter';
import { SidebarHeader } from './SidebarHeader';
import { StandaloneNavigationItem } from './StandaloneNavigationItem';
import { useNavigation } from './useNavigation';

export const AppSidebar = () => {
  const { t } = useTranslation();
  const {
    filteredStandaloneItems,
    filteredNavigationGroups,
    isActive,
    isGroupDefaultOpen,
  } = useNavigation();

  return (
    <Sidebar collapsible='icon' aria-label={t('navigation.mainNavigation')}>
      <SidebarHeader />

      <SidebarContent>
        <SidebarGroup>
          <SidebarMenu>
            {/* Standalone navigation items */}
            {filteredStandaloneItems.map(item => (
              <StandaloneNavigationItem
                key={item.name}
                item={item}
                isActive={isActive}
              />
            ))}

            {/* Navigation groups */}
            {filteredNavigationGroups.map(group => (
              <NavigationGroup
                key={group.label}
                group={group}
                isActive={isActive}
                isGroupDefaultOpen={isGroupDefaultOpen}
              />
            ))}
          </SidebarMenu>
        </SidebarGroup>
      </SidebarContent>

      <SidebarFooter isActive={isActive} />
      <SidebarRail />
    </Sidebar>
  );
};
